import { XControl } from '../../commons';
import { IDropDownSeekerProps } from './IDropDownSeekerProps';
import { IDropDownSeekerState } from './IDropDownSeekerState';
import styles from './XComboBox.module.scss';

export class XDropDownSeeker extends XControl<HTMLDivElement, IDropDownSeekerProps, IDropDownSeekerState> {
    private _Start: number;
    private _End: number;
    private _Text?: string | null;
    public constructor(props: IDropDownSeekerProps) {
        super(props);
        this._Start = 0;
        this._End = 0;
        this._Text = '';
        this.state = {
            ...this.state,
            //text: undefined,
        };
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setText = this.setText.bind(this);
    }

    public componentDidMount(): void {
        super.componentDidMount();
        // const selection = window.getSelection();
        // if(selection && selection.rangeCount > 0) {
        //     const current = selection.getRangeAt(0);
        //     const range = document.createRange();
        //     range.setStart(current.startContainer, this._Start);
        //     range.setEnd(current.endContainer, this._End);
        //     selection.removeAllRanges();
        //     selection.addRange(range);
        // }
    }
    
    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }

    private onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        event.stopPropagation();
        event.currentTarget.focus();
    }

    private onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
        // const {currentTarget} = event;
        // const {textContent} = currentTarget;
        // this.setText(textContent + event.key);
        // switch(event.key) {
        //     case 'ArrowRight': 
        //         break;
        //     case 'ArrowLeft':
        //         break;
        //     default:
        //         const selection = window.getSelection();
        //         if(selection && selection.rangeCount > 0 && textContent) {
        //             const current = selection.getRangeAt(0);
        //             const range = document.createRange();
        //             const start: number =
        //                 textContent.length > (current.startOffset + 1)
        //                 ? (current.startOffset + 1)
        //                 : current.startOffset;
        //             const end: number =
        //                 textContent.length > (current.endOffset + 1)
        //                 ? (current.endOffset + 1)
        //                 : current.endOffset;
        //             range.setStart(current.startContainer, start);
        //             range.setEnd(current.endContainer, end);
        //             selection.removeAllRanges();
        //             selection.addRange(range);
        //         }
        //         break;
        // }
    }
    private onKeyUp(event: React.KeyboardEvent<HTMLDivElement>) {
        //event.stopPropagation();
        const {currentTarget} = event;
        const {textContent} = currentTarget;
        //this._Text = textContent;
        this.setText(textContent);
        switch(event.key) {
            case 'ArrowRight': 
                break;
            case 'ArrowLeft':
                break;
            default:
                break;
        }        
    }

    public setText(value?: string | null) {
        this._Text = value;
        this.props.onText?.(value);
        // const selection = window.getSelection();
        // if(selection && selection.rangeCount > 0 && value) {
        //     const current = selection.getRangeAt(0);
        //     this._Start = current.startOffset;
        //     this._End = current.endOffset;
        // }
        // this.setState({text: value});
    }

    public render(): React.ReactNode {
        return (
            <div className={styles.XDropDownSeeker} data-show={this.props.show}>
                <div className={styles.XEdit} contentEditable="true"
                    suppressContentEditableWarning={true}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={this.onClick}
                    onKeyDown={this.onKeyDown}
                    onKeyUp={this.onKeyUp}
                >
                    {/* {this._Text} */}
                </div>
            </div>
        );
    }
}
